import { render, staticRenderFns } from "./b2b-dialog-envio-customers.vue?vue&type=template&id=bc0c19de&scoped=true"
import script from "./b2b-dialog-envio-customers.vue?vue&type=script&lang=js"
export * from "./b2b-dialog-envio-customers.vue?vue&type=script&lang=js"
import style0 from "./b2b-dialog-envio-customers.vue?vue&type=style&index=0&id=bc0c19de&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc0c19de",
  null
  
)

export default component.exports